var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTerminalOperations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4858 67.4578C41.4858 66.9055 41.0381 66.4578 40.4858 66.4578H0.999998C0.447714 66.4578 0 66.9055 0 67.4578V99C0 99.5523 0.447715 100 1 100H40.4858C41.0381 100 41.4858 99.5523 41.4858 99V67.4578Z",
    fill: "#29ABE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11C19 10.4477 18.5523 10 18 10H5C4.44772 10 4 10.4477 4 11V66C4 66.5523 4.44772 67 5 67H18C18.5523 67 19 66.5523 19 66V11Z",
    fill: "#29ABE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9C15 8.44772 14.5523 8 14 8H8C7.44772 8 7 8.44772 7 9V9C7 9.55228 7.44772 10 8 10H14C14.5523 10 15 9.55228 15 9V9Z",
    fill: "#F7931E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97 99.01C97 99.5623 96.5523 100 96 100L54 100C53.4477 100 53 99.5523 53 99V28.2067C53 28.0703 53.0276 27.9352 53.0832 27.8107C56.0716 21.1235 63.467 16.5736 72 16C81.8043 15.3387 93.3243 20.044 96.9132 27.8082C96.9716 27.9344 97.0001 28.0677 97.0002 28.2067C97.0199 47.1599 97.0007 79.6754 97 99.01Z",
    fill: "#29ABE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1656 38.1026C53.1656 37.5503 52.7179 37.1026 52.1656 37.1026H48.1236C47.5713 37.1026 47.1236 37.5503 47.1236 38.1026V45.2382C47.1236 45.7905 47.5713 46.2382 48.1236 46.2382H52.1656C52.7179 46.2382 53.1656 45.7905 53.1656 45.2382V38.1026Z",
    fill: "#F7931E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.125 66.4128C30.1888 60.3672 30.2528 54.2992 30.2952 48.2534C30.3378 44.8948 33.4014 42.163 37.2308 42.1182L48.932 41.9614",
    stroke: "#F7931E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1905 2.55262C11.1905 2.19436 12.0628 0 21.4024 0C30.742 0 46.6768 3.85132 46.6768 3.85132C46.6768 3.85132 54.2506 3.73936 56.8462 2.77654C59.4416 1.8137 53.5698 6.18002 46.3576 7.14286C39.1456 8.10568 26.2318 3.78414 23.8064 3.58262C21.3812 3.3811 11.1905 2.8885 11.1905 2.55262Z",
    fill: "#F7931E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1656 34.953H51.6976C49.5276 33.5648 49.6978 30.945 52.0168 29.691H53.1868",
    fill: "#00AEEF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1656 68.54H51.6976C49.5276 67.1518 49.6978 64.532 52.0168 63.278H53.1868",
    fill: "#00AEEF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1656 97.649H51.6976C49.5276 96.2606 49.6978 93.6408 52.0168 92.387H53.1868",
    fill: "#00AEEF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6724 29.7582H98.1404C100.31 31.1464 100.14 33.7662 97.8212 35.0202H96.6512",
    fill: "#00AEEF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.013 63.278H97.9702C100.842 64.6664 100.63 67.2862 97.566 68.54H96.013",
    fill: "#00AEEF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6512 92.387H98.1192C100.289 93.7752 100.119 96.395 97.8 97.649H96.63",
    fill: "#00AEEF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalOperations);
export default __webpack_public_path__ + "static/media/TerminalOperations.3b9ed864f2acc5b8d250b313c172a2ca.svg";
export { ForwardRef as ReactComponent };